import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InjectionToken, NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxsModule } from '@ngxs/store';
// import { StoreModule } from '@ngrx/store';
import {
  ActionRequiredState,
  AppEnvironmentState,
  HeaderModule,
  PermissionsState,
  UserState,
  SharedModule,
  GeaTranslateHttpLoader,
  SidebarV2Module,
  IconModule,
  PageLayoutModule,
  FeatureFlagConfigurationState,
  HeaderConfig,
  LIBRARY_CONFIG,
} from '@gea/digital-ui-lib';
import {
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from '@azure/msal-angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeactivateGuard } from './candeactivate-guard.service';
import { HrtLoaderComponent } from './shared/components/hrt-loader/hrt-loader.component';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from 'src/environments/model/environment.model';

export function HttpLoaderFactory(http: HttpClient, environment: EnvironmentConfiguration) {
  return new GeaTranslateHttpLoader(http, environment.localizationStorageURL, [
    'i18n/1/support/',
  ]);
}

export const HEADER_CONFIG = new InjectionToken<HeaderConfig>('HeaderConfig');

@NgModule({
  declarations: [AppComponent, HrtLoaderComponent],
  imports: [
    NgxsModule.forRoot([
      UserState,
      ActionRequiredState,
      AppEnvironmentState,
      PermissionsState,
      FeatureFlagConfigurationState,
    ]),
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    HeaderModule.forRoot(HEADER_CONFIG),
    TranslateModule.forRoot({
      extend: true,
      defaultLanguage: 'en-US',
      loader: {
        deps: [HttpClient, ENVIRONMENT_CONFIG],
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
      },
    }),
    MsalModule,
    SharedModule,
    PageLayoutModule,
    SidebarV2Module,
    IconModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    MatSnackBarModule,
    ProgressSpinnerModule,
  ],
  providers: [
    {
      provide: LIBRARY_CONFIG,
      useFactory: (env: EnvironmentConfiguration) => {
        return {
          ...env,
          baseUrl: env.portal.baseURL ?? env.baseURL,
          backendInfoUrl: (env.portal.baseURL ?? env.baseURL) + 'geaid/v1/info',
          legalDocumentsStorageURL: env.storageURL,
          passwordResetAuthority: env.oAuth.passwordResetAuthority
        };
      },
      deps: [ENVIRONMENT_CONFIG],
    },
    {
      provide: 'baseUrl',
      useFactory: (env: EnvironmentConfiguration) => env.portal.baseURL ?? env.baseURL,
      deps: [ENVIRONMENT_CONFIG],
    },
    {
      provide: 'subscriptionKey',
      useValue: '',
    },
    {
      provide: 'storageURL',
      useFactory: (env: EnvironmentConfiguration) => env.localizationStorageURL,
      deps: [ENVIRONMENT_CONFIG],
    },
    {
      provide: 'iconPath',
      useFactory: (env: EnvironmentConfiguration) => env.iconStorageURL,
      deps: [ENVIRONMENT_CONFIG],
    },
    MsalService,
    ConfirmDeactivateGuard,
    MatDialog,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
